import script from "./ReferenceDatatable.vue?vue&type=script&setup=true&lang=js"
export * from "./ReferenceDatatable.vue?vue&type=script&setup=true&lang=js"

import "./ReferenceDatatable.vue?vue&type=style&index=0&id=b4c0f48c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4c0f48c"]])

export default __exports__